import { redWordInfo,ovatBill,invoice } from 'redevConfig'
const list = (redWordInfo && redWordInfo.list) || ''
const add = (redWordInfo && redWordInfo.add) || ''
const detail = (redWordInfo && redWordInfo.detail) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''
const invoiceEdit = (invoice && invoice.add) || ''

const redInfoList = list ? require(`redevelopment/outputManage/redWordInfo/${list.templateName}`) : require('./view/redInfoList.html')
const addRedInfo = add ? require(`redevelopment/outputManage/redWordInfo/${add.templateName}`) : require('./view/add_redInfo.html')
const redInfoDetail = detail ? require(`redevelopment/outputManage/redWordInfo/${detail.templateName}`) : require('./view/redInfoDetail.html')
const checkBillDetailPage = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`) : require('../ovatBill/view/checkBillDetailCtrl.html')
const invoiceEditPage = invoiceEdit ? require(`redevelopment/outputManage/invoice/${invoiceEdit.templateName}`) : require('../../fillOpenManage/invoice1/view/invoiceEdit.html')

// 你这里是个抽象路由
export const Router = {
    state: 'outputManage.FOManage.redInfo',
    config: {
        url: '/redInfo',
        template: '<div ui-view></div>',
        // controller: 'redInfoCtrl',
        abstract: true,
        title: '红字信息表',
        default: 'outputManage.FOManage.redInfo.list',
    },
}

export const redInfoListRouter = {
    state: 'outputManage.FOManage.redInfo.list',
    config: {
        url: '/list',
        template: redInfoList,
        controller: 'redInfoListCtrl',
    },
}

// 新增路由
export const addRouter = {
    state: 'outputManage.FOManage.redInfo.add',
    config: {
        url: '/add',
        template: addRedInfo,
        controller: 'addRedInfoCtrl',
        title: '新增红字信息表',
    },
}

// 编辑路由
export const editRouter = {
    state: 'outputManage.FOManage.redInfo.edit',
    config: {
        url: '/edit/:infoId',
        template: addRedInfo,
        controller: 'editRedInfoCtrl',
        title: '编辑红字信息表',
    },
}

// 详情路由
export const detailRouter = {
    state: 'outputManage.FOManage.redInfo.detail',
    config: {
        url: '/detail/:infoId',
        template: redInfoDetail,
        controller: 'redInfoDetailCtrl',
        title: '红字信息表详情',
    },
}

// 销售单明细

export const RedInfoBillDetailCtrlRouter = {
    state: 'outputManage.FOManage.redInfo.checkBillDetail',
    config: {
        url: '/checkBillDetail/:billId',
        template: checkBillDetailPage,
        controller: 'checkBillDetailCtrl',
        title: '销售单明细',
    },
}

export const redInvoiceRouter = {
    state: 'outputManage.FOManage.redInfo.opened',
    config: {
        url: '/opened/:waitId/:infoId',
        template: invoiceEditPage,
        controller: 'invoiceEditCtrl',
        title: '新增红字发票',
    },
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/Routers.js